export default "__VITE_ASSET__CXeUMWDq__"